<template>
  <div :class="alignmentClass">
    <template v-for="(button, index) in buttons">
      <v-tooltip v-if="!button.menu && !button.spacer && checkVisible(button, scope)"
                 :key="index"
                 top
                 :disabled="!button.hint">
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs"
                 :disabled="checkDisabled(button, scope)"
                 :color="getColor(button, scope)"
                 :text="button.flat"
                 :large="button.large"
                 :block="button.block"
                 :depressed="button.depressed"
                 :outlined="button.outline"
                 :small="button.small"
                 :icon="!button.buttonLabel"
                 :class="button.class"
                 v-on="on"
                 @click.stop="onButtonClickHandler(button, scope)">
            <v-progress-circular v-if="button.spinIcon"
                                 :color="getColor(button, scope)"
                                 :size="18"
                                 :width="2"
                                 indeterminate />
            <v-icon v-else-if="button.icon" :small="button.small" :class="button.buttonLabel ? 'mr-2' : ''">
              {{ getIcon(button, scope) }}
            </v-icon>
            <span v-if="button.buttonLabel"
                  :class="button.loadingText ? 'loading-text' : ''">
              {{ button.buttonLabel }}
            </span>
          </v-btn>
        </template>
        <span v-if="button.hint">{{ button.hint }}</span>
      </v-tooltip>

      <v-spacer v-else-if="button.spacer" :key="index" />
      <v-menu v-else-if="button.menu && menuItems(button.items, scope).length"
              :key="index"
              :right="button.menuDirection === 'right'"
              :left="button.menuDirection === 'left' || !button.menuDirection"
              :offset-x="button.menuOffsetX === true"
              :offset-y="button.menuOffsetY === true"
              @click.stop>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs"
                 :color="getColor(button, scope)"
                 :text="button.flat"
                 :large="button.large"
                 :block="button.block"
                 :depressed="button.depressed"
                 :outlined="button.outline"
                 :small="button.small"
                 :icon="!button.buttonLabel"
                 :class="button.class"
                 v-on="on">
            <v-icon v-if="button.icon" :small="button.small" :class="button.buttonLabel ? 'mr-2' : ''">
              {{ getIcon(button, scope) }}
            </v-icon>
            <span v-if="button.buttonLabel">
              {{ button.buttonLabel }}
            </span>
          </v-btn>
        </template>
        <v-list>
          <v-subheader v-if="button.menuTitle">
            {{ button.menuTitle }}
          </v-subheader>
          <v-list-item v-for="(item, subIndex) in menuItems(button.items, scope)"
                       :key="subIndex"
                       :disabled="checkDisabled(item, scope)"
                       @click="onButtonClickHandler(item, scope)">
            <v-list-item-content>
              <v-list-item-title class="pr-2">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'RegDynamicButtons',
  props: {
    scope: {
      type: Object,
      default: () => {
        return {}
      }
    },
    buttons: {
      type: Array,
      default: () => []
    },
    align: {
      type: String,
      default: 'right'
    },
    scopeItemProp: {
      type: String,
      default: ''
    }
  },
  computed: {
    alignmentClass() {
      if (this.align === 'right') {
        return 'justify-end layout pa-0 ma-0 gap-h'
      } else if (this.align === 'center') {
        return 'justify-center layout pa-0 ma-0 gap-h'
      } else {
        return 'justify-start layout pa-0 ma-0 gap-h'
      }
    }
  },
  methods: {
    onButtonClickHandler(button, scope) {
      this.$emit('click', { button, scope })
      if (button.click) {
        button.click(this.scopeItemProp ? scope[this.scopeItemProp] : scope, button)
      }
    },
    checkDisabled(item, scope) {
      if (typeof item.disabled === 'function') {
        return item.disabled(this.scopeItemProp ? scope[this.scopeItemProp] : scope, scope)
      } else if (item.disabled !== undefined) {
        return Boolean(item.disabled)
      }

      return false
    },
    checkVisible(item, scope) {
      if (typeof item.visible === 'function') {
        return item.visible(this.scopeItemProp ? scope[this.scopeItemProp] : scope, scope)
      } else if (item.visible !== undefined) {
        return Boolean(item.visible)
      }

      return true
    },
    menuItems(items, scope) {
      return _.filter(items, item => {
        return this.checkVisible(item, scope)
      })
    },
    getIcon(item, scope) {
      if (typeof item.icon === 'function') {
        return item.icon(this.scopeItemProp ? scope[this.scopeItemProp] : scope, scope)
      } else if (item.icon !== undefined) {
        return String(item.icon)
      }

      return ''
    },
    getColor(item, scope) {
      if (typeof item.color === 'function') {
        return item.color(this.scopeItemProp ? scope[this.scopeItemProp] : scope, scope)
      } else if (item.color !== undefined) {
        return String(item.color)
      }

      return 'primary'
    }
  }
}
</script>

<style lang="scss">
.selected-items {
  display: flex;
}
</style>
